import {
	listTransaksiKonsumen,
	listHistoryPaylinkKonsumen,
	infoTransaksiKonsumen,
	detailTransaksi,
	pagination,
	search,
	queryListTransaksi
} from "./state"

const mutations = {
	setListTransaksiKonsumen: (state, res) => {
		if (state.listTransaksiKonsumen.data !== undefined) {
			state.listTransaksiKonsumen.data = [...state.listTransaksiKonsumen.data, ...res.data];
		} else {
			state.listTransaksiKonsumen = res
		}
	},
	setListHistoryPaylinkKonsumen: (state, res) => {
		if (state.listHistoryPaylinkKonsumen.data !== undefined) {
			state.listHistoryPaylinkKonsumen.data.list_transaksi_paylink = [...state.listHistoryPaylinkKonsumen.data.list_transaksi_paylink, ...res.data.list_transaksi_paylink];
		} else {
			state.listHistoryPaylinkKonsumen = res
		}
	},
	setInfoTransaksiKonsumen: (state, res) => {
		state.infoTransaksiKonsumen = res
	},
	setDetailTransaksi: (state, res) => {
		state.detailTransaksi = res
	},
	resetListTransaksiKonsumen: (state) => {
		state.listTransaksiKonsumen = listTransaksiKonsumen()
	},
	resetListHistoryPaylinkKonsumen: (state) => {
		state.listHistoryPaylinkKonsumen = listHistoryPaylinkKonsumen()
	},
	resetInfoTransaksiKonsumen: (state, res) => {
		state.infoTransaksiKonsumen = infoTransaksiKonsumen()
	},
	resetDetailTransaksi: (state) => {
		state.detailTransaksi = detailTransaksi()
	},

	// search
	setSearch: (state, search) => {
		state.search.key = search;
	},
	resetSearch: (state) => {
		state.search = search();
	},
	setIsSearch: (state, bool) => {
		state.isSearch = bool
	},

	// query
	setQueryListTransaksi: (state, query) => {
		state.queryListTransaksi = query
	},
	resetQueryListTransaksi: (state) => {
		state.queryListTransaksi = queryListTransaksi()
	},

	// filter
	setNextPagination: (state, payload) => {
		state.pagination.length = payload.data.length
		state.pagination.pageNumber++
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
	},
	resetPagination: (state, e) => {
		state.pagination = pagination()
	},

	setScrollPosition: (state, positionY) => {
		state.scrollPosition = positionY - 100
	}
}

export default mutations